export default "__VITE_ASSET__BdhQXxMx__"